import { CALL_API } from '../../../middleware/api';

export const SAVE_NDA_SUCCESS = Symbol('SAVE_NDA_SUCCESS');

/**
 * Load NDA director (Harvey & Company signer) details.
 *
 * @param {number} userId User id.
 * @param {Function} afterSuccess Callback after success request.
 */
export function loadNdaDirector(userId, afterSuccess) {
  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/users/${userId}`,
      afterSuccess,
    },
  };
}

/**
 * Save NDA.
 *
 * @param {object} body Request body.
 * @param {number} body.companyId Company id.
 * @param {number} body.moduleId Director (Harvey & Company signer) id.
 * @param {string} body.type NDA type: HarveyNDA or ClientSpecificNDA.
 * @param {number} [body.buyerId] Buyer id, required for ClientSpecificNDA.
 * @param {number} body.contactId Target signer contact id.
 * @param {number} body.contactEmailId Target signer email id.
 * @param {Function} afterSuccess Callback after success request.
 * @param {Function} afterError Callback after error request.
 */
export function saveNda({ companyId, ...body }, afterSuccess, afterError) {
  return {
    [CALL_API]: {
      method: 'post',
      path: `/api/v1/companies/${companyId}/ndas`,
      body,
      skipGlobalErrorHandler: true,
      successType: SAVE_NDA_SUCCESS,
      afterSuccess,
      afterError,
    },
  };
}

/**
 * Send saved NDA via DocuSign.
 *
 * @param {number} companyId Company id.
 * @param {number} ndaId Saved NDA id.
 * @param {Function} afterSuccess Callback after success request.
 * @param {Function} afterError Callback after error request.
 */
export function sendNda(companyId, ndaId, afterSuccess, afterError) {
  return {
    [CALL_API]: {
      method: 'post',
      path: `/api/v1/companies/${companyId}/ndas/${ndaId}/send`,
      skipGlobalErrorHandler: true,
      afterSuccess,
      afterError,
    },
  };
}

/**
 * Generate saved NDA file.
 *
 * @param {number} companyId Company id.
 * @param {number} ndaId Saved NDA id.
 * @param {string} format File format: docx or pdf.
 * @param {Function} afterSuccess Callback after success request.
 * @param {Function} afterError Callback after error request.
 */
export function previewNda(companyId, ndaId, format, afterSuccess, afterError) {
  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/companies/${companyId}/ndas/${ndaId}/preview`,
      query: { format },
      skipGlobalErrorHandler: true,
      afterSuccess,
      afterError,
    },
  };
}
